import { render, staticRenderFns } from "./ProductCategoryComponent.vue?vue&type=template&id=72d92224&scoped=true"
import script from "./ProductCategoryComponent.vue?vue&type=script&lang=js"
export * from "./ProductCategoryComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductCategoryComponent.vue?vue&type=style&index=0&id=72d92224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d92224",
  null
  
)

export default component.exports